import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "buttons-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "button-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.cancel,
        activeValidate: _ctx.etatEquipement !== undefined,
        headerTitle: _ctx.$t('equipement.condition.title'),
        onConfirm: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$t('equipement.condition.subtitle')) + " ", 1),
            _createVNode(_component_ReglePastille, { cle: "demandeIntervention.etatEquipementDefaut" })
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etatsEquipement, (etat) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.pick(etat)),
                class: _normalizeClass(["button-container", _ctx.getClass(etat)]),
                key: etat.id
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(etat.libelle), 1)
              ], 10, _hoisted_3))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["onCancel", "activeValidate", "headerTitle", "onConfirm"])
    ]),
    _: 1
  }))
}